module.exports = __webpack_public_path__ + "static/media/zind_nyamirambo1.abd05df4.jpg";